import cn from "classnames";
import styles from "./Stepper.module.css";
export interface Step {
  label: string;
}

type StepperProps = { steps: Step[]; active: number };

export function Stepper(props: StepperProps) {
  return (
    <div className={styles.stepper}>
      {props.steps.map((step, index) => (
        <div
          // biome-ignore lint/suspicious/noArrayIndexKey: Needed for steps
          key={index}
          className={cn(styles.step, {
            [styles.active]: index === props.active,
          })}
        >
          {index + 1}. {step.label}
        </div>
      ))}
    </div>
  );
}
